import Button from 'Component/Button';
import { runWPConsentPixel } from 'Component/WPEvents/WPEvents.util';
import { CookiePopup as SourceCookiePopup } from 'SourceComponent/CookiePopup/CookiePopup.component';
import BrowserDatabase from 'Util/BrowserDatabase';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

import { COOKIE_POPUP } from './CookiePopup.config';

import './CookiePopup.override.style';

/** @namespace Pwa/Component/CookiePopup/Component */
export class CookiePopup extends SourceCookiePopup {
    acceptCookies() {
        const { code } = this.props;
        const param = `${COOKIE_POPUP}_${code}`;

        BrowserDatabase.setItem(true, param, ONE_MONTH_IN_SECONDS);
        this.setState({ isAccepted: true });
        runWPConsentPixel();
    }

    renderCTA() {
        return (
            <div
                block="CookiePopup"
                elem="CTA"
                onClick={this.acceptCookies}
                onKeyDown={this.acceptCookies}
                role="button"
                tabIndex={0}
            >
                <Button>{__('Got it')}</Button>
            </div>
        );
    }

    render() {
        const { cookieText } = this.props;
        const { isAccepted } = this.state;

        if (!cookieText || isAccepted) {
            return null;
        }

        return (
            <div block="CookiePopup" elem="Container">
                <div block="CookiePopup">
                    {this.renderCookieText()}
                    {this.renderCTA()}
                </div>
            </div>
        );
    }
}

export default CookiePopup;
